function Footer() {
  return (
    <footer>
      <div className="footer-inner">

        <div className="social-links">
          <a href="https://www.instagram.com/nila.instyle/" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
          <a href="https://www.pinterest.com/" target="_blank" rel="noreferrer"><i className="fab fa-pinterest"></i></a>
        </div>
        <p className="footer-copy">&copy; 2026 Nila Instyle. All rights reserved.</p>

        {/* <p className="footer-credit">Website by Sanjay Palanisamy</p> */}
      </div>
    </footer>
  );
}

export default Footer;
